import { IEnvironment } from "./environment";

export const testEnv: IEnvironment = {
  env: "test",
  api: {
    protocol: "https",
    host: "api-aurora.codebehind.tech",
  },
};
